angular
  .module('sentences')
  .component('sentences', {
    template: require('./sentences.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function SentencesViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'sentences';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $resource(`${APIURL}/admin/sentences`).get().$promise
          .then((data) => {
            this.sentences = data.sentences;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.gotoModifySubmit = (sentence) => {
          $resource(`${APIURL}/admin/sentences/${sentence.CODE}`).save(sentence).$promise
            .then(() => {
              alert($translate.instant('수정되었습니다.'));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/sentences/sentences.component.js